export default "__VITE_ASSET__B7KTr0Yr__"